
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Clock } from "lucide-react";
import { Business } from "@/types";

interface HoursCardProps {
  business: Business;
  formatDay: (day: string) => string;
}

const HoursCard: React.FC<HoursCardProps> = ({ business, formatDay }) => {
  if (!business.hours) {
    return null;
  }

  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-medium mb-4 flex items-center">
          <Clock className="h-5 w-5 mr-2 text-eco-500" />
          Hours
        </h3>
        <div className="space-y-2">
          {Object.entries(business.hours).map(([day, hours]) => (
            <div key={day} className="flex justify-between">
              <span className="font-medium">{formatDay(day)}</span>
              <span>
                {hours.open} - {hours.close}
              </span>
            </div>
          ))}
          {business.hours && Object.keys(business.hours).length < 7 && (
            <div className="text-sm text-muted-foreground mt-2">
              * Closed on unlisted days
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default HoursCard;
